<template>
  <div class="SearchFilter">
    <div class="SearchFilter-facetParent Block card is-rounded has-border">
      <h5 class="SearchFilter-title">
        {{ title }}
      </h5>
      <ul
        v-if="hasFilters"
        class="a"
      >
        <li
          v-for="(tag) in tags"
          :key="tag.text"
          class="Form-field Form-field--checkbox"
        >
          <input
            :id="tag.key"
            v-model="filterQuery"
            :value="tag.key"
            :disabled="isValueDisabled(tag) || isDisabled"
            class="Form-input"
            type="checkbox"
            @click.prevent="updateQueryInStore(tag)"
          >
          <label
            :for="tag.key"
            :class="['Form-label', {'is-disabled': isValueDisabled(tag) || isDisabled }]"
            @click.prevent="updateQueryInStore(tag)"
          >

            <a
              :href="tag.url"
              :rel="anchorRelAttributeValue(tag)"
              @click.prevent
            >
              <i
                v-if="tag.name === 'Best Apprenticeship Employers'"
                class="fa fa-trophy"
              />

              {{ tag.name }}
              <span
                v-if="showCount"
                class="SearchFilters-count"
              >
                ({{ tag.count }})
              </span>
            </a>
          </label>
        </li>
      </ul>
      <ul
        v-else
        class="field"
      >
        <li
          v-for="index in fallbackCount"
          :key="index"
          class="SearchFilter-facetTitle"
        >
          <a
            href="#"
            class="is-disabled SearchFilter-link"
            @click.prevent
          >
            <span class="placeholder">&nbsp;</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import filterQueryUpdateMixin from './filter-component-mixin';

export default {
  mixins: [filterQueryUpdateMixin],

  props: {
    tags: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style type="text/scss" lang="scss" scoped>
@import "../../../../scss/abstracts/abstracts";

.Icon-trophy {
  color: color($primary-color);
  margin-right: 5px;
  margin-top: 5px;
}

.placeholder {
  background: color('grey', 'lightest');
  display: block;
  border-right: 4px;
  margin-left: 30px;
  height: 20px;
  border-radius: 4px;
  position: relative;
  margin-bottom: .6rem;

  &:before {
    content: '';
    height: 20px;
    width: 20px;
    position: relative;
    left: -30px;
    display: inline-block;
    background: color('grey', 'lightest');
  }

  //padding: 3px 5px;
}

.checkbox label {
  display: flex;
  align-items: center;

  &::before {
    flex-shrink: 0;
  }
}

.Form-field--checkbox .Form-input:checked + .Form-label a{
  color: color($primary-color);
}
label {
  align-items: flex-start;
  a {
    color: $text-color;
    margin-top: -2px;
    flex-grow: 1;
    &:hover, &:focus {
      color: color($primary-color);
    }
  }

  &.is-disabled {
    a {
      cursor: default;
      color: color('grey');
    }

    color: color('grey');

    &::before {
      background: color('grey', 'light') !important;
    }
  }
}

</style>
